import store from "@/store";
import NgoPlan from "./store";
export default [
  {
    path: "/annual-plan",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("NgoPlan")) store.registerModule("NgoPlan", NgoPlan);
      next();
    },
    meta: {
      instructionsSlug: "annual-plans",
    },
    children: [
      {
        path: ":year",
        name: "annual-plan",
        props: true,
        component: () => import("./pages/plan/index.vue"),
        meta: {
          slug: "ngo_plans",
          instructionsSlug: "annual-plans",
        },
      },
      {
        path: "/plan-execution",
        name: "plan-execution",
        props: true,
        component: () => import("./pages/execution/index.vue"),
        meta: {
          instructionsSlug: "annual-plans",
        },
      },
    ],
  },
];
